import React from 'react';
import '../../css/PreviewPDF.css';

const PDFHeader: React.FC = () => {
  const createdAt = new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  return (
      <div className="pdf-header-meta">
        <span>Curated on {createdAt}</span>
        <img src="/logo.png" alt="OTA Prime" className="pdf-logo" />
      </div>
  );
};

export default PDFHeader;
